var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import MilestoneLogo from "../assets/Navbar/MilestoneLogo.svg";
import Settings from "../assets/Navbar/Settings.svg";
import Notifications from "../assets/Navbar/Notifications.svg";
import Feedback from "../assets/Navbar/Feedback.svg";
import back from "../assets/Navbar/Back.svg";
import { Header, Container, Nav, NavLogo, NavLinkContainer, NavTab, IconContainer, Icon, ProfilePicture, BreadCrumbs, Back, BackTitle, CurrentPage, PPContainer, DeadNavTab, } from "./Navbar.styles";
import { Link, useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import { MenuItem } from "@material-ui/core";
import { useMsal } from "@azure/msal-react";
export var Navbar = function (_a) {
    var _b = _a.crumbsLoading, crumbsLoading = _b === void 0 ? true : _b, isLoggedIn = _a.isLoggedIn, isAdmin = _a.isAdmin, profilePicture = _a.profilePicture, crumbs = _a.crumbs;
    var _c = useMsal(), instance = _c.instance, accounts = _c.accounts;
    var _d = __read(useState(false), 2), openProfileMenu = _d[0], setOpenProfileMenu = _d[1];
    var profileRef = useRef(null);
    var handleClick = function () {
        history.goBack();
    };
    var history = useHistory();
    var handleLogout = function () {
        instance.logoutRedirect();
    };
    return (React.createElement(Header, null,
        React.createElement(Container, null,
            React.createElement(Nav, null,
                React.createElement(NavLogo, { src: MilestoneLogo }),
                isLoggedIn && (React.createElement(React.Fragment, null,
                    React.createElement(NavLinkContainer, null,
                        React.createElement(DeadNavTab, { to: "/utility", activeClassName: "selected" }, "Utility"),
                        React.createElement(DeadNavTab, { to: "/HR", activeClassName: "selected" }, "HR"),
                        React.createElement(NavTab, { to: "/dashboard", activeClassName: "selected" }, "Teams"),
                        React.createElement(NavTab, { to: "/metrics", activeClassName: "selected" }, "Metrics & Reports"),
                        React.createElement(DeadNavTab, { to: "/feedback", activeClassName: "selected" }, "Feedback & Rewards"),
                        React.createElement(DeadNavTab, { to: "/communication", activeClassName: "selected" }, "Communication"),
                        React.createElement(DeadNavTab, { to: "/training", lastchild: "true" }, "Training")),
                    React.createElement(IconContainer, null,
                        React.createElement(Link, { to: {
                                pathname: "https://forms.monday.com/forms/a4575adf3bc18ea4673ce8b561c20756?r=use1",
                            }, target: "_blank" },
                            React.createElement(Icon, { height: 20, src: Feedback })),
                        React.createElement(Icon, { src: Notifications }),
                        isAdmin && (React.createElement(Link, { to: "/admin" },
                            React.createElement(Icon, { src: Settings }))),
                        React.createElement(PPContainer, null,
                            React.createElement(ProfilePicture, { ref: profileRef, src: profilePicture, onClick: function () {
                                    setOpenProfileMenu(true);
                                } }),
                            React.createElement(Menu, { open: openProfileMenu, anchorEl: profileRef.current, keepMounted: true, onClose: function () { return setOpenProfileMenu(false); } },
                                React.createElement(MenuItem, { onClick: handleLogout }, "Log out")))))))),
        isLoggedIn && (React.createElement(Container, null,
            React.createElement(BreadCrumbs, null,
                React.createElement(Back, { onClick: handleClick },
                    React.createElement("img", { src: back }),
                    React.createElement(BackTitle, null, "Back")),
                React.createElement(CurrentPage, null, !crumbsLoading && crumbs && crumbs.join(" / ")))))));
};
//# sourceMappingURL=Navbar.js.map